function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 512,
  height: 512
}, /*#__PURE__*/React.createElement("rect", {
  x: 384.908,
  width: 127.092,
  height: 512,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  width: 123.461,
  height: 512,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  y: 421.22,
  width: 512,
  height: 90.7802,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 105.305,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.617 335.559L400.298 421.202H108.936L254.617 335.559Z",
  fill: "#747474"
}), /*#__PURE__*/React.createElement("rect", {
  x: 123.461,
  y: 212.244,
  width: 261.447,
  height: 32.6808,
  fill: "#7B7B7B"
}), /*#__PURE__*/React.createElement("rect", {
  x: 123.461,
  y: 143.251,
  width: 261.447,
  height: 32.6808,
  fill: "#7B7B7B"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 256,
  fill: "#7D76A5"
}));

var SvgSubstack = function SvgSubstack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubstack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/substack.a0cd57fb.svg";
export { ForwardRef as ReactComponent };